<template>
    <div class="body d-flex pb-lg-3 mb-5 mb-xl-0">
        <div class="container-xxl">
            <div class="row clearfix">
                <div class="col-md-12">
                        <div class="d-sm-flex mb-1 justify-content-end align-items-center main-button-area justify-content-center-mob">
                            <button class="btn btn-primary" @click="openvenueModal('create')"><i class="icofont icofont-plus"></i>
                                ΝΕΟΣ ΧΩΡΟΣ ΕΚΔΗΛΩΣΗΣ</button>
                        </div>
                </div>
            </div>
            <div class="card-body table-responsive ">
                <table id="venueTable" class="table table-hover mb-0 myTable w-100">
    <thead>
        <tr>
            <th style="width:20%;"><div>Όνομα</div></th>
            <th style="width:18%;"><div>Διεύθυνση</div></th>
            <th style="width:16%;"><div>Χωρητικότητα</div></th>
            <th style="width:30%;"><div>Περιγραφή</div></th>

            <th style="text-align: right; ">Ενέργειες</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(venue, index) in data" :key="venue.id">
            <td>{{ venue.title }}</td>
            <td>{{ venue.address }}</td>
            <td>{{ venue.capacity }}</td>
            <td>{{ venue.description }}</td>
            <td class="d-flex justify-content-end">
                <button class="btn shadow-sm bg-white" @click="openvenueModal('update', venue)">
                    <i class="icofont icofont-edit fs-6 text-success"></i>
                </button>
                <button class="btn shadow-sm bg-white" @click="confirmAction('update', venue)">
                    <i class="icofont icofont-trash fs-6 text-danger"></i>
                </button>
            </td>
        </tr>
        <!-- Show No Data row if there's no data -->
        <tr v-if="!data || !data.length">
            <td colspan="2" class="text-center">Δεν βρέθηκαν δεδομένα</td>
        </tr>
    </tbody>
</table>

<nav aria-label="Page navigation" v-if="data && data.length">
    <ul class="pagination mt-4 d-flex align-items-center" v-if="paginationLinks && paginationLinks.length > 0">
        <!-- Previous button -->
        <li class="page-item" :class="{ disabled: !paginationLinks[0].url }">
            <router-link 
                v-if="paginationLinks[0].url" 
                :to="{ path: 'venues', query: { ...filters, page: getPageFromUrl(paginationLinks[0].url) } }" 
                class="btn btn-outline-primary"
            >
                <i class="icofont-arrow-left"></i>
            </router-link>
            <span class="btn btn-outline-primary " v-else>
                <i class="icofont-arrow-left"></i>
            </span>
        </li>

        <!-- Page numbers -->
        <li class="page-item ms-2" 
            v-for="(paginationLink, index) in paginationLinks.slice(1, paginationLinks.length - 1)" 
            :key="index" 
            :class="{ active: paginationLink.active }"
        >
            <router-link 
                v-if="paginationLink.url" 
                :to="{ path: 'venues', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }" 
                class="page-link rounded"
                v-html="paginationLink.label"
            ></router-link>
            <span class="page-link" v-else v-html="paginationLink.label"></span>
        </li>

        <!-- Next button -->
        <li class="page-item ms-2" :class="{ disabled: !paginationLinks[paginationLinks.length - 1].url }">
            <router-link 
                v-if="paginationLinks[paginationLinks.length - 1].url" 
                :to="{ path: 'venues', query: { ...filters, page: getPageFromUrl(paginationLinks[paginationLinks.length - 1].url) } }" 
                class="btn btn-primary text-white"
            >
                Επόμενη σελίδα >
            </router-link>
            <span class="btn btn-primary text-white" v-else>
                Επόμενη σελίδα >
            </span>
        </li>
    </ul>
</nav>
            </div>
        </div>

        <!-- venue Modal -->
        <div class="modal fade" id="venueModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="venueModalLabel">{{ isUpdate ? 'Επεξεργασία Κατηγορίας' : 'Δημιουργία Κατηγορίας' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="submitVenue">
                            <div class="mb-3">
                                <label for="title" class="form-label"> Τίτλος</label>
                                <input v-model="venueForm.title" type="text" id="title" class="form-control" required />
                            </div>
                            <div class="mb-3">
                                <label for="address" class="form-label"> Διεύθυνση</label>
                                <input v-model="venueForm.address" type="text" id="address" class="form-control" required />
                            </div>
                            <div class="mb-3">
                                <label for="capacity" class="form-label"> Χωρητικότητα</label>
                                <input v-model="venueForm.capacity" type="number" min="0" id="capacity" class="form-control" required />
                            </div>
                            <div class="mb-3">
                                <label for="description" class="form-label"> Περιγραφή</label>
                                <textarea v-model="venueForm.description" id="description" class="form-control" required></textarea> 
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Άκυρο</button>
                                <button type="submit" class="btn btn-primary">{{ isUpdate ? 'Αποθήκευση' : 'Δημιουργία' }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Confirmation Modal -->
        <div class="modal fade" id="confirmationModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="confirmationModalLabel">Επιβεβαίωση ενέργειας</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>{{ confirmationMessage }}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Άκυρο</button>
                        <button type="button" class="btn btn-primary" @click="submitAction">Υποβολή</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { fetchAll, createUpdateVenue, deleteJobVenue } from '@/services/venues';
import { useRoute, useRouter } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { useToast } from 'vue-toastification';
import { useHead } from '@vueuse/head';

export default {
    name: 'venues',
    setup() {
        const route = useRoute();
        const router = useRouter();

        const { data, paginationLinks, fetchData } = useFetchData(fetchAll, {page: route.query.page || 1}, {page: 1});
        const confirmationMessage = ref('');
        const actionType = ref('');
        const venueToActOn = ref(null);
        const isUpdate = ref(false);

        const venueForm = ref({
            title: ''
        });

        const openvenueModal = (type, venue = null) => {
            isUpdate.value = type === 'update';
            if (venue) {
                venueForm.value.title = venue.title;
                venueForm.value.address = venue.address;
                venueForm.value.capacity = venue.capacity;
                venueForm.value.description = venue.description;

                venueToActOn.value = venue;
            } else {
                venueForm.value.title = '';
                venueForm.value.address = '';
                venueForm.value.capacity = '';
                venueForm.value.description = '';

                venueToActOn.value = null;
            }
            $('#venueModal').modal('show');
        };

        const submitVenue = async () => {
            let response;

            if (isUpdate.value) {
                response = await createUpdateVenue(venueToActOn.value.id, venueForm.value);
            } else {
                response = await createUpdateVenue(null, venueForm.value);
            }

            if (response.data.success) {
                useToast().success(response.data.message);
                fetchData();
                $('#venueModal').modal('hide');
            } else {
                useToast().error(response.data.message);
            }
        };

        const confirmAction = (type, venue) => {
            actionType.value = type;
            venueToActOn.value = venue;
            confirmationMessage.value = `Είστε σίγουροι ότι θέλετε να διαγράψετε το χώρο εκδήλωσης: ${venue.title}?`;
            $('#confirmationModal').modal('show');
        };

        const submitAction = async () => {
            const r = await deleteJobVenue(venueToActOn.value.id);
            if (r.data.success) {
                useToast().success(r.data.message);
                fetchData();
            } else {
                useToast().error(r.data.message);
            }
            $('#confirmationModal').modal('hide');
        };

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({path: '/venues', query: {...route.query, search: $("#main-search-input").val()}});
            }, 300);
        };

        onMounted(() => {
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            useHead({
                title: 'Χώροι Εκδηλώσεων - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου',
                meta: [
                    { name: 'description', content: 'Χώροι Εκδηλώσεων - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου' },
                    { property: 'og:title', content: 'Χώροι Εκδηλώσεων - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου' },
                    { property: 'og:description', content: 'Χώροι Εκδηλώσεων - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου' }
                ]
            });
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
            $("#main-search-input").val("");
        });

        return { data, paginationLinks, getPageFromUrl, confirmAction, submitAction, confirmationMessage, openvenueModal, venueForm, submitVenue, isUpdate };
    }
};
</script>

<style scoped>
.checkbox-wrapper {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
}

.card.selected-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

tr.selected, div.selected {
    background: #b1afaf;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 28px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 28px;
}

.select2-container--default .select2-selection--single {
    height: 38px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
    background-color: #007bff;
    border-color: #007bff;
    color: #fff;
}

.select2-container .select2-selection--single {
    z-index: 9000;
}

.select2-container .select2-selection--multiple {
    z-index: 9000;
}

.select2-dropdown {
    z-index: 9000 !important;
}

.modal.show .modal-dialog {
    z-index: 1050;
}

.modal-backdrop.show {
    z-index: 1040;
}
@media only screen and (max-width: 48em) {
    .justify-content-center-mob{
        justify-content: center !important;
        display: flex;
    }
}
</style>
